import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { SelfServeSignupPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageCompletedEventTracking';
export class OnboardingNamePageViewedEventTracking extends SelfServeSignupPageCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_NAME_PAGE_VIEWED;
}
